/*
 * Newsletter forms with data-klaviyo-list subscribe straight to that Klaviyo
 * list through Klaviyo's public client API. The Shopify customer form would
 * land in whatever list the Klaviyo-Shopify sync is set to instead.
 */
(function () {
  'use strict';

  if (window.newsletterKlaviyoBound) return;
  window.newsletterKlaviyoBound = true;

  // company_id is the account's public site key, the same one klaviyo.js loads with.
  const ENDPOINT = 'https://a.klaviyo.com/client/subscriptions?company_id=VchLHL';
  const REVISION = '2026-07-15';

  function subscribe(email, listId, source) {
    return fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: REVISION },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source,
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email,
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: listId } } }
        }
      })
    });
  }

  function showAlert(form, status) {
    form.querySelectorAll('.alert').forEach((alert) => alert.remove());
    const template = form.querySelector(`template[data-klaviyo-${status}]`);
    if (template) form.append(template.content.cloneNode(true));
  }

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.dataset.klaviyoList) return;
    event.preventDefault();

    const button = form.querySelector('[type="submit"]');
    const email = form.querySelector('input[type="email"]').value.trim();
    button.disabled = true;

    let subscribed = false;
    try {
      const response = await subscribe(email, form.dataset.klaviyoList, form.dataset.klaviyoSource);
      subscribed = response.ok;
      if (!subscribed) console.warn('[newsletter] Klaviyo rejected the sign-up:', response.status);
    } catch (error) {
      console.warn('[newsletter] Klaviyo not reachable:', error);
    }

    button.disabled = false;
    if (subscribed) form.reset();
    showAlert(form, subscribed ? 'success' : 'error');
  });
})();
